// utils/priceFormatter.js
export const formatPrice = (price) => {
  if (!price && price !== 0) return 'Price on request';
  
  // If price is a number
  if (typeof price === 'number') {
    return `₹${price.toLocaleString('en-IN')}`;
  }
  
  // If price is a string
  if (typeof price === 'string') {
    const numPrice = parseFloat(price);
    if (!isNaN(numPrice)) {
      return `₹${numPrice.toLocaleString('en-IN')}`;
    }
  }
  
  return 'Price on request';
};
